import { JoiningProgress } from "@vivagym-joining/joining-progress";

document.addEventListener("DOMContentLoaded", async () => {
	const localization = VgHelpers.getCountryAndLanguage();
	let lang = localization.lang;

	window.notificationsActive = true;

	JoiningProgress.onDataReady( initStep );

	function initStep(progress){

		console.log("Loaded progress data:", progress);

		let selectedGymId = null;

		// Check the loaded progress data to find the gym ID from step 2
		if (progress && progress.getSelectGymStep()) {
			selectedGymId = progress.getGymId();
			lang = progress.getGymCountry()?.toLowerCase();
			const vgForms = new VGForms();
			progress.renderStepResume(vgForms);
		}

		const options = {
			mapSelectorId: "map",
			searchDistance: 7000,
			centerOnUser: true,
			isJoining: true,
			selectedGymId: selectedGymId,
			lang: lang,
		};
		let vgMap = new VgMap(options);

		const selectCountrySelected = document.querySelector(
			".vg-custom-select-country--item-selected"
		);
		const selectCountryItems = document.querySelector(
			".vg-custom-select-country--items"
		);
		const selectCountryItem = document.querySelectorAll(
			".vg-custom-select-country--item"
		);

		selectCountrySelected?.addEventListener("click", function () {
			selectCountrySelected.classList.add("open");
			selectCountryItems.style.display = "block";
		});

		selectCountryItem?.forEach(function (option) {
			option.addEventListener("click", function () {
				selectCountrySelected.innerHTML = this.innerHTML;
				selectCountryItems.style.display = "none";
				selectCountrySelected.classList.remove("open");
				if (this.hasAttribute("data-lang")) {
					vgMap.updateLanguage(this.getAttribute("data-lang"));
				}
			});
		});

		document.addEventListener("click", function (event) {
			if (!event.target.closest(".vg-custom-select-country")) {
				if (selectCountryItems && selectCountrySelected) {
					selectCountryItems.style.display = "none";
					selectCountrySelected.classList.remove("open");
				}
			}
		});

		document.addEventListener("vgMapReady", (event) =>{
			selectCountryItem?.forEach(function (option) {
				if (option.getAttribute("data-lang") === lang) {
					option.click();
				}
			});
		});
	
	}
});
